module.exports = (typeof globalThis !== 'undefined' ? globalThis : self)['maplibregl'];